import script from "./PieChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PieChart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__